module.exports = __webpack_public_path__ + "media/images/default/banner_C-7d964c5c46cc98b83727c9e7099153f4.png";